(() => {
  'use strict';
  const page = document.getElementById('dyson-product');
  if (!page) return;
  const market = JSON.parse(document.getElementById('dy-market-data').textContent);
  const ui = JSON.parse(document.getElementById('dy-i18n-data').textContent);
  const t = (key, params = {}) => Object.entries(params).reduce((value, [name, replacement]) => value.replaceAll(`{${name}}`, String(replacement)), ui[key] || key);
  const marketForm = document.getElementById('dy-market-form');
  const marketToggle = document.getElementById('dy-market-toggle');
  const marketOptions = document.getElementById('dy-market-options');
  const marketButtons = [...marketOptions.querySelectorAll('[data-dy-country]')];
  const desktopPicker = matchMedia('(min-width:1101px) and (hover:hover) and (pointer:fine)');
  const marketRetryKey = `dyson-market:${market.handle}`;
  const marketPositionKey = `dyson-position:${market.handle}`;
  let marketPosition = null;
  const closeMarket = () => { marketOptions.hidden = true; marketToggle.setAttribute('aria-expanded', 'false'); marketPosition = null; };
  const selectMarket = (country, manual = false, position = scrollY) => {
    const selection = market.selection[country];
    if (!selection) return;
    const destination = new URL(location.href);
    const root = market.roots[selection.language].replace(/\/$/, '');
    destination.pathname = destination.pathname.includes('products_preview') ? `${root}/products_preview` : `${root}/products/${market.handle}`;
    destination.searchParams.set('country', country);
    marketForm.elements.country_code.value = country;
    marketForm.elements.language_code.value = selection.language;
    marketForm.querySelectorAll('input[name="return_to"]').forEach(input => { input.value = destination.pathname + destination.search + destination.hash; });
    try {
      if (manual) { localStorage.setItem('dyson-country-preference', country); sessionStorage.setItem(marketPositionKey, JSON.stringify({country, y: position})); sessionStorage.removeItem(marketRetryKey); }
      else sessionStorage.setItem(marketRetryKey, `${country}:${selection.language}`);
    } catch {}
    marketForm.requestSubmit();
  };
  marketToggle.addEventListener('click', () => {
    if (!desktopPicker.matches) return;
    if (marketOptions.hidden) {
      marketPosition = scrollY; marketOptions.hidden = false; marketToggle.setAttribute('aria-expanded', 'true');
      marketButtons.find(button => button.dataset.dyCountry === market.country)?.focus({preventScroll:true});
    } else closeMarket();
  });
  marketButtons.forEach(button => button.addEventListener('click', () => { const y = marketPosition ?? scrollY; closeMarket(); selectMarket(button.dataset.dyCountry, true, y); }));
  marketOptions.addEventListener('keydown', event => {
    const current = marketButtons.indexOf(document.activeElement); let next;
    if (event.key === 'ArrowDown') next = (current + 1) % marketButtons.length;
    if (event.key === 'ArrowUp') next = (current - 1 + marketButtons.length) % marketButtons.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = marketButtons.length - 1;
    if (next !== undefined) { event.preventDefault(); marketButtons[next].focus({preventScroll:true}); }
    if (event.key === 'Escape') { event.preventDefault(); closeMarket(); marketToggle.focus({preventScroll:true}); }
  });
  document.addEventListener('click', event => { if (!event.target.closest('.dy-market-picker')) closeMarket(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !marketOptions.hidden) { closeMarket(); marketToggle.focus({preventScroll:true}); } });
  desktopPicker.addEventListener('change', () => { if (!desktopPicker.matches) closeMarket(); });
  const currentUrl = new URL(location.href);
  const parameter = currentUrl.searchParams.get('country')?.toUpperCase();
  const pathPrefix = currentUrl.pathname.split('/')[1].toLowerCase();
  const explicitLanguage = Object.keys(market.roots).find(language => market.roots[language].split('/')[1].toLowerCase() === pathPrefix);
  let savedCountry, retriedCountry;
  try { savedCountry = localStorage.getItem('dyson-country-preference'); if (sessionStorage.getItem(marketRetryKey) === `${market.country}:${market.language}`) retriedCountry = market.country; } catch {}
  let targetCountry;
  if (market.selection[parameter]) targetCountry = parameter;
  else if (explicitLanguage) {
    targetCountry = explicitLanguage === 'de' ? (market.country === 'AT' ? 'AT' : 'DE') : Object.keys(market.selection).find(country => market.selection[country].language === explicitLanguage);
  } else if (market.selection[savedCountry]) targetCountry = savedCountry;
  else if (market.selection[retriedCountry]) targetCountry = retriedCountry;
  else {
    const browserLanguage = navigator.language.toLowerCase();
    const preferred = Object.keys(market.selection).find(country => market.selection[country].language.toLowerCase().split('-')[0] === browserLanguage.split('-')[0]);
    targetCountry = browserLanguage === 'de-at' ? 'AT' : preferred || 'DE';
  }
  const target = market.selection[targetCountry];
  if (market.country !== targetCountry || market.language.toLowerCase() !== target.language.toLowerCase() || market.currency !== target.currency) {
    let attempted = false;
    try { attempted = sessionStorage.getItem(marketRetryKey) === `${targetCountry}:${target.language}`; } catch {}
    if (!attempted) { selectMarket(targetCountry); return; }
    page.querySelectorAll('[data-checkout]').forEach(button => { button.disabled = true; button.setAttribute('aria-disabled', 'true'); });
    const error = page.querySelector('.dy-toast'); error.textContent = t('marketError'); error.hidden = false;
    return;
  }
  const choice = market.selection[market.country];
  marketToggle.querySelector('[data-dy-market-label]').textContent = `${choice.name} · ${market.currency}`;
  try {
    sessionStorage.removeItem(marketRetryKey);
    const stored = JSON.parse(sessionStorage.getItem(marketPositionKey) || 'null');
    if (stored && stored.country === market.country && Number.isFinite(stored.y) && stored.y >= 0) {
      sessionStorage.removeItem(marketPositionKey);
      const restore = () => requestAnimationFrame(() => window.scrollTo({top:stored.y, behavior:'instant'}));
      if (document.readyState === 'complete') restore(); else window.addEventListener('load', restore, {once:true});
    }
  } catch {}

  const data = JSON.parse(document.getElementById('dy-data').textContent);
  const variantData = JSON.parse(document.getElementById('dy-variants-data').textContent);
  // Preserve Shopify's native cents; show the same precision as checkout.
  if (market.currency !== 'EUR') {
    const money = new Intl.NumberFormat(market.language, {style:'currency', currency:market.currency, minimumFractionDigits:2, maximumFractionDigits:2});
    variantData.variants.forEach(variant => {
      variant.priceText = money.format(variant.price / 100);
      variant.compareText = money.format(variant.compareAtPrice / 100);
      variant.savingText = money.format((variant.compareAtPrice - variant.price) / 100);
    });
  }

  let selectedVariant = variantData.variants.find(variant => variant.id === page.dataset.variant);
  let checkoutPending = false;
  const gallery = document.getElementById('dy-gallery');
  const galleryImage = document.getElementById('dy-gallery-image');
  const pagination = gallery.querySelector('.dy-gallery-pages');
  const videoDialog = document.getElementById('dy-video-modal');
  const video = videoDialog.querySelector('video');
  const infoDialog = document.getElementById('dy-info-modal');
  const heroMedia = page.querySelector('.dy-hero-media');
  const heroImage = document.getElementById('dy-hero-image');
  let ignoreZoomUntil = 0;
  let activeIndex = 0;
  let previousFocus;
  let touchStartX;
  let touchStartY;
  let toastTimer;
  function open(dialog) {
    previousFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('dy-modal-open');
    dialog.querySelector('[data-close]')?.focus();
  }
  function close(dialog) {
    if (dialog === videoDialog) { video.pause(); video.removeAttribute('src'); video.load(); }
    dialog.close();
    document.body.classList.remove('dy-modal-open');
    previousFocus?.focus();
  }
  document.querySelectorAll('.dy-page dialog').forEach(dialog => {
    dialog.querySelector('[data-close]')?.addEventListener('click', () => close(dialog));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(dialog); });
    dialog.addEventListener('click', event => { if (event.target === dialog) {
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(dialog);
    }});
  });
  function show(index) {
    activeIndex = (index + data.gallery.length) % data.gallery.length;
    galleryImage.src = data.gallery[activeIndex];
    const description = data.galleryAlt?.[activeIndex] || t('imageNumber', {index:activeIndex + 1,total:data.gallery.length});
    galleryImage.alt = `Dyson Supersonic™ ${selectedVariant?.name || 'Nickel/Kupfer'} – ${description}`;
    gallery.querySelector('[data-gallery-caption]').textContent = description;
    if (heroImage) {
      heroImage.src = data.gallery[activeIndex];
      heroImage.alt = galleryImage.alt;
      heroImage.classList.toggle('dy-media-contain', activeIndex === 1);
      heroMedia.querySelector('[data-media-count]').textContent = `${activeIndex + 1} / ${data.gallery.length}`;
      heroMedia.querySelector('[data-media-caption]').textContent = description;
      heroMedia.querySelectorAll('[data-media-index]').forEach((button, i) => button.setAttribute('aria-current', String(i === activeIndex)));
    }
    pagination.querySelectorAll('button').forEach((button,i) => button.setAttribute('aria-current', String(i === activeIndex)));
  }
  data.gallery.forEach((src, index) => {
    const button = document.createElement('button');
    button.type = 'button'; button.textContent = index + 1;
    button.setAttribute('aria-label', t('imageNumber', {index:index + 1,total:data.gallery.length}));
    button.addEventListener('click', () => show(index));
    pagination.append(button);
  });
  page.querySelectorAll('[data-gallery-open]').forEach(button => button.addEventListener('click', () => {
    if (Date.now() < ignoreZoomUntil) return;
    show(activeIndex); open(gallery);
  }));
  heroMedia?.querySelectorAll('[data-media-index]').forEach(button => button.addEventListener('click', () => show(Number(button.dataset.mediaIndex))));
  heroMedia?.querySelector('[data-media-prev]').addEventListener('click', () => show(activeIndex - 1));
  heroMedia?.querySelector('[data-media-next]').addEventListener('click', () => show(activeIndex + 1));
  heroMedia?.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    show(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
  });
  let heroTouchStart;
  const heroStage = heroMedia?.querySelector('.dy-media-zoom');
  heroStage?.addEventListener('touchstart', event => {
    heroTouchStart = event.touches.length === 1 ? {x:event.touches[0].clientX, y:event.touches[0].clientY} : null;
  }, {passive:true});
  heroStage?.addEventListener('touchend', event => {
    if (!heroTouchStart) return;
    const dx = event.changedTouches[0].clientX - heroTouchStart.x;
    const dy = event.changedTouches[0].clientY - heroTouchStart.y;
    heroTouchStart = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      ignoreZoomUntil = Date.now() + 500;
      show(activeIndex + (dx < 0 ? 1 : -1));
    }
  }, {passive:true});
  heroStage?.addEventListener('touchcancel', () => {heroTouchStart = null;}, {passive:true});
  gallery.querySelector('.dy-gallery-prev').addEventListener('click', () => show(activeIndex - 1));
  gallery.querySelector('.dy-gallery-next').addEventListener('click', () => show(activeIndex + 1));
  gallery.addEventListener('keydown', event => {if(event.key === 'ArrowLeft') show(activeIndex - 1); if(event.key === 'ArrowRight') show(activeIndex + 1);});
  galleryImage.addEventListener('touchstart',event => {touchStartX=event.changedTouches[0].clientX;touchStartY=event.changedTouches[0].clientY;}, {passive:true});
  galleryImage.addEventListener('touchend',event => {
    const dx=event.changedTouches[0].clientX-touchStartX,dy=event.changedTouches[0].clientY-touchStartY;
    if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.3) show(activeIndex+(dx<0?1:-1));
  },{passive:true});
  page.querySelectorAll('[data-video]').forEach(button => button.addEventListener('click', () => {
    const url = button.dataset.video;
    const message = videoDialog.querySelector('.dy-video-message');
    document.getElementById('dy-video-title').textContent = button.dataset.videoTitle;
    video.hidden = !url; message.hidden = Boolean(url);
    message.textContent = t('videoUnavailable');
    if (url) { video.src=url; video.poster=button.querySelector('img')?.src || ''; }
    open(videoDialog);
    if(url) video.play().catch(() => {});
  }));
  page.querySelectorAll('[data-info]').forEach(button => button.addEventListener('click', () => {
    const item = data.info[button.dataset.info];
    document.getElementById('dy-info-title').textContent = item.title;
    infoDialog.querySelector('.dy-info-body').textContent = item.body;
    infoDialog.querySelector('[data-dy-returns-detail]')?.toggleAttribute('hidden', button.dataset.info !== 'offer_returns');
    open(infoDialog);
  }));
  function toast(message) {
    const element=page.querySelector('.dy-toast');
    element.textContent=message;element.hidden=false;
    clearTimeout(toastTimer);toastTimer=setTimeout(()=>{element.hidden=true;},6500);
  }
  const quantityInput = document.getElementById('dy-quantity');
  const quantityPlus = page.querySelector('[data-quantity-plus]');
  const quantityNotice = page.querySelector('[data-quantity-notice]');
  let quantityNoticeTimer;
  function resetQuantity() {
    if (quantityInput) quantityInput.value = '1';
  }
  function positionQuantityNotice() {
    if (!quantityNotice || quantityNotice.hidden || !quantityPlus) return;
    const viewport = window.visualViewport;
    const left = (viewport?.offsetLeft || 0) + 12;
    const top = (viewport?.offsetTop || 0) + 12;
    const right = left + (viewport?.width || window.innerWidth) - 24;
    const bottom = top + (viewport?.height || window.innerHeight) - 24;
    const anchor = quantityPlus.getBoundingClientRect();
    const sticky = page.querySelector('.dy-purchasebar')?.getBoundingClientRect();
    const safeTop = sticky && sticky.top <= top && sticky.bottom > top
      ? Math.min(bottom, sticky.bottom + 8) : top;
    quantityNotice.style.left = `${left}px`;
    quantityNotice.style.maxWidth = `${Math.max(1, Math.min(280, right - left))}px`;
    let size = quantityNotice.getBoundingClientRect();
    let x = anchor.left + anchor.width / 2 - size.width / 2;
    const above = anchor.top - size.height - 10;
    let y = above;
    if (above < safeTop) {
      // Beside the control leaves the purchase button below it unobscured.
      const rightSpace = right - anchor.right - 10;
      const leftSpace = anchor.left - left - 10;
      const useRight = rightSpace >= leftSpace;
      const available = Math.max(rightSpace, leftSpace);
      if (available >= 120) {
        quantityNotice.style.maxWidth = `${Math.min(280, available)}px`;
        size = quantityNotice.getBoundingClientRect();
        x = useRight ? anchor.right + 10 : anchor.left - size.width - 10;
        y = anchor.top + (anchor.height - size.height) / 2;
      } else {
        y = anchor.bottom + 10;
      }
    }
    quantityNotice.style.left = `${Math.max(left, Math.min(x, right - size.width))}px`;
    quantityNotice.style.top = `${Math.max(safeTop, Math.min(y, bottom - size.height))}px`;
  }
  function showQuantityNotice() {
    resetQuantity();
    if (!quantityNotice) return;
    clearTimeout(quantityNoticeTimer);
    quantityNotice.hidden = false;
    positionQuantityNotice();
    quantityNoticeTimer = setTimeout(() => { quantityNotice.hidden = true; }, 3000);
  }
  resetQuantity();
  quantityInput?.addEventListener('input', resetQuantity);
  quantityInput?.addEventListener('change', resetQuantity);
  quantityPlus?.addEventListener('click', showQuantityNotice);
  window.addEventListener('resize', positionQuantityNotice, { passive: true });
  window.addEventListener('scroll', positionQuantityNotice, { passive: true });
  window.visualViewport?.addEventListener('resize', positionQuantityNotice, { passive: true });
  window.visualViewport?.addEventListener('scroll', positionQuantityNotice, { passive: true });
  window.addEventListener('pageshow', event => {
    resetQuantity();
    if (event.persisted) {
      checkoutPending = false;
      syncPurchaseState();
      clearTimeout(quantityNoticeTimer);
      if (quantityNotice) quantityNotice.hidden = true;
    }
  });
  function syncPurchaseState() {
    const available = Boolean(selectedVariant?.available) && selectedVariant.colorKey !== 'fuchsia';
    page.dataset.available = String(available);
    page.querySelectorAll('[data-checkout]').forEach(button => {
      button.disabled = checkoutPending || !available;
      button.setAttribute('aria-disabled', String(button.disabled));
      const label = button.querySelector('[data-cta-label]');
      const subtitle = button.querySelector('[data-cta-subtitle]');
      if (label && subtitle) {
        label.textContent = checkoutPending ? t('preparing') : available ? button.dataset.ctaDefaultLabel : t('soldOut');
        subtitle.textContent = checkoutPending ? t('wait') : available ? button.dataset.ctaDefaultSubtitle : t('displayOnly');
      } else {
        button.textContent = available ? variantData.checkoutLabel : t('soldOut');
      }
      if (checkoutPending) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    });
    page.querySelectorAll('[data-color-variant]').forEach(button => { button.disabled = checkoutPending; });
  }
  function selectVariant(id, updateUrl = false) {
    if (checkoutPending) return;
    const variant = variantData.variants.find(item => item.id === String(id));
    if (!variant || !variantData.galleries[variant.colorKey]?.length) return;
    selectedVariant = variant;
    page.dataset.variant = variant.id;
    page.dataset.color = variant.colorKey;
    data.gallery = variantData.galleries[variant.colorKey];
    page.querySelectorAll('[data-color-name]').forEach(element => { element.textContent = variant.name; });
    page.querySelectorAll('[data-color-variant]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.colorVariant === variant.id));
    });
    const title = page.querySelector('[data-product-title]');
    if (title) title.textContent = variantData.titleTemplate.replaceAll(variantData.colorBaseName, variant.name);
    const breadcrumb = page.querySelector('[data-product-breadcrumb]');
    if (breadcrumb) breadcrumb.textContent = t('breadcrumb', {color:variant.name});
    page.querySelectorAll('[data-variant-price]').forEach(element => { element.textContent = variant.priceText; });
    const hasDiscount = variant.compareAtPrice > variant.price;
    const compare = page.querySelector('[data-variant-compare]');
    if (compare) {
      compare.textContent = variant.compareText;
      compare.closest('.dy-original').hidden = !hasDiscount;
    }
    page.querySelectorAll('[data-sticky-compare]').forEach(element => {
      element.textContent = variant.compareText;
      element.hidden = !hasDiscount;
    });
    const saving = page.querySelector('[data-variant-saving]');
    if (saving) {
      saving.hidden = !hasDiscount;
      saving.replaceChildren(document.createTextNode(t('saving', {amount:variant.savingText}) + ' '));
      const percent = document.createElement('span');
      percent.className = 'dy-saving-percent';
      percent.textContent = t('approximately', {percent:variant.savingPercent});
      saving.append(percent, document.createElement('br'));
    }
    const clearance = page.querySelector('[data-clearance]');
    if (clearance) clearance.hidden = !hasDiscount;
    const availability = page.querySelector('[data-variant-availability]');
    if (availability) availability.textContent = variant.available && variant.colorKey !== 'fuchsia' ? t('available') : t('soldOutAvailability');
    heroMedia.querySelectorAll('[data-media-index]').forEach((button, i) => {
      button.querySelector('img').src = data.gallery[i];
      button.setAttribute('aria-label', t('imageDescription', {index:i + 1,total:data.gallery.length,color:variant.name,description:data.galleryAlt[i]}));
    });
    page.querySelectorAll('[data-gallery-cover]').forEach(image => { image.src = data.gallery[0]; });
    syncPurchaseState();
    show(0);
    resetQuantity();
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', url);
    }
  }
  page.querySelectorAll('[data-color-variant]').forEach(button => {
    button.addEventListener('click', () => selectVariant(button.dataset.colorVariant, true));
  });
  window.addEventListener('popstate', () => {
    const id = new URL(window.location.href).searchParams.get('variant');
    selectVariant(id || variantData.variants.find(variant => variant.colorKey === 'nickel')?.id);
  });
  selectVariant(page.dataset.variant);
  page.querySelectorAll('[data-checkout]').forEach(button => button.addEventListener('click', async () => {
    if (checkoutPending) return;
    if (!selectedVariant?.available || selectedVariant.colorKey === 'fuchsia') { toast(t('soldOutToast')); return; }
    if(page.dataset.preview==='true') { toast(t('localPreview')); return; }
    const variant=selectedVariant.id;
    // Frontend quantity only; duplicate orders are reviewed by the merchant.
    const quantity=1;
    resetQuantity();
    if(!/^\d+$/.test(variant) || variant==='0') {toast(t('unavailable'));return;}
    // An independent Storefront Cart creates a target-only checkout without
    // mutating the existing AJAX storefront cart. Release QA must verify both.
    checkoutPending = true;
    syncPurchaseState();
    try {
      const response=await fetch('/api/2026-10/graphql.json',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({query:'mutation ProductCheckout($input: CartInput!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) { cartCreate(input: $input) { cart { checkoutUrl totalQuantity cost { totalAmount { amount currencyCode } } lines(first: 10) { nodes { quantity attributes { key value } merchandise { ... on ProductVariant { id } } } } } userErrors { message } warnings { code message } } }',variables:{input:{lines:[{merchandiseId:`gid://shopify/ProductVariant/${variant}`,quantity,attributes:variantData.giftAttributes || []}],buyerIdentity:{countryCode:market.country}},country:market.country,language:choice.storefrontLanguage}})
      });
      if(!response.ok)throw new Error(`Checkout HTTP ${response.status}`);
      const result=await response.json();
      const checkout=result.data?.cartCreate;
      if(result.errors?.length || checkout?.userErrors?.length || !checkout?.cart?.checkoutUrl)throw new Error('Checkout unavailable');
      const cart=checkout.cart;
      const lines=cart.lines?.nodes;
      if(checkout.warnings?.length || !Array.isArray(lines) || lines.length!==1 || lines[0].merchandise?.id!==`gid://shopify/ProductVariant/${variant}` || lines[0].quantity!==quantity || cart.totalQuantity!==quantity)throw new Error('Selected product unavailable');
      if ((variantData.giftAttributes || []).some(expected => !lines[0].attributes?.some(actual => actual.key === expected.key && actual.value === expected.value))) throw new Error('Gift information unavailable');
      if (cart.cost?.totalAmount?.currencyCode !== market.currency) throw new Error('Market currency mismatch');
      const url=new URL(checkout.cart.checkoutUrl,window.location.origin);
      url.searchParams.set('locale',market.language);
      window.location.assign(url.href);
    } catch(error) {
      toast(t('checkoutError'));
      checkoutPending = false;
      syncPurchaseState();
    }
  }));
  // Source uses exclusive accordions within these three distinct groups.
  ['.dy-product-details details, .dy-included details, .dy-styling details','.dy-attachments details'].forEach(selector => {
    const panels=page.querySelectorAll(selector);
    panels.forEach(panel=>panel.addEventListener('toggle',()=>{
      if(!panel.open)return;
      panels.forEach(other=>{if(other!==panel)other.open=false;});
    }));
  });
})();
